export const CHANGE_SETTING = "CHANGE_SETTING"; // 改变系统设置
export const CLOSE_SIDEBAR = "CLOSE_SIDEBAR"; // 关闭sidebar
export const CHANGE_ACTIVEINDEX = "CHANGE_ACTIVEINDEX"; // 改变活动的菜单项index
export const TOGGLE_DEVICE = "TOGGLE_DEVICE"; // 切换设备
export const CHANGE_MULTIPLE_LENGTH = "CHANGE_MULTIPLE_LENGTH"; // 表格批量勾选存储

export const USER_LOGIN = "USER_LOGIN"; // 用户登录
export const USER_LOGOUT = "USER_LOGOUT"; // 用户登出
